/**
 * Public-site information architecture.
 *
 * Product menu items are live capabilities only. Anything still in development
 * stays on /product under a tagged "Coming" strip, not in the header.
 */
export const PRODUCT_AREAS = [
  {
    to: '/product#contacts',
    label: 'Contacts',
    blurb: 'Live details, meeting context, and private notes.',
  },
  {
    to: '/product#intelligence',
    label: 'Intelligence',
    blurb: 'A weekly digest and a daily brief on your market.',
  },
  {
    to: '/product#events',
    label: 'Networking',
    blurb: 'Conferences and meet-ups matched to your industry.',
  },
  {
    to: '/product#analytics',
    label: 'Analytics',
    blurb: 'Who engaged after the meeting, and how a team compares.',
  },
];

export const PRODUCT_MORE = [
  {
    to: '/product',
    label: 'Platform overview',
    blurb: 'The system behind the introduction.',
  },
  {
    to: '/how-it-works',
    label: 'How it works',
    blurb: 'Share, capture, remember, continue.',
  },
];

export const PRODUCT_TEAMS = {
  to: '/enterprise',
  label: 'Teams',
  blurb: 'A company hub, seats, and cards if you want them.',
};

export const SOLUTION_ITEMS = [
  {
    to: '/professionals',
    label: 'Professionals',
    blurb: 'For individuals. No company account required.',
  },
  {
    to: '/enterprise',
    label: 'Teams',
    blurb: 'For organisations that need the network to stay.',
  },
];

export const PRIMARY_LINKS = [
  { to: '/why-velox', label: 'About' },
  { to: '/help', label: 'Help' },
];

export function isProductPath(pathname) {
  return pathname === '/product' || pathname === '/how-it-works';
}

export function isSolutionsPath(pathname) {
  return pathname === '/professionals' || pathname === '/enterprise';
}
